import React, { useEffect } from 'react'

import 'antd/dist/antd.css'
import { notification, Icon, Button } from 'antd'
import SearchWhiteList from './scenes/SearchWhiteList/index'
import './index.css'

function Admin () {
  return (
    <div className='boxStyle'>
        <SearchWhiteList />
    </div>
  )
}

export default Admin
